import React  from "react";

import growmoney from  "../media/growmoney.png"
import bhjl from  "../media/BJHL.mp4"
import drone from "../media/Photos/Drone.jpg";
import land from "../media/Photos/Land 1.jpg";
import smartfarming from "../media/Photos/Smart Farming.jpg";
import strawberry from "../media/Photos/Strawberry.jpg";

const Gallery = () => {

    
    return(
        <div className="about-container">
        <div className="content">
             <h1>Gallery</h1>
             
             <video autoPlay={false} src={bhjl} controls height={300} style={{margin: 10}}></video>
             <img src={growmoney} alt="growmonwy" height={'140vh'} style={{margin: 10}}/>
             <img src={drone} alt="growmonwy" height={'140vh'} style={{margin: 10}}/>
             <img src={land} alt="growmonwy" height={'140vh'} style={{margin: 10}}/>
             <img src={smartfarming} alt="growmonwy" height={'140vh'} style={{margin: 10}}/>
             <img src={strawberry} alt="growmonwy" height={'140vh'} style={{margin: 10}}/>
        </div>
        </div>
    )
}


export default Gallery;